import { createFileRoute } from "@tanstack/react-router";
import ArkansasBlueCrossInsurance, {
  config,
} from "@/pages/ArkansasBlueCrossInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/arkansas-blue-cross-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Arkansas BCBS TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Arkansas Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Arkansas BCBS TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Arkansas Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/arkansas-blue-cross-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/arkansas-blue-cross-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ArkansasBlueCrossInsurance />;
}
